import { useCallback, useRef } from 'react'

/**
 * Returns a stable function reference that always calls the latest version of `fn`.
 * Useful to prevent unnecessary useMemo/useCallback recomputation when a callback
 * identity changes on every render but the memoized value doesn't need to update.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useStableCallback<T extends (...args: any[]) => any>(fn: T): T {
  const ref = useRef<T>(fn)
  ref.current = fn
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback((...args: Parameters<T>) => ref.current(...args), []) as unknown as T
}
